<template>
  <v-card color="grey lighten-5" flat>
    <v-layout row wrap>
      <v-flex xs12 md12 sm12>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title>{{$t('Payment-List')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="odemeEkle()" flat><v-icon>add_box</v-icon> {{ $t('save_button') }}</v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 md12 sm12>
        <pnrodeme ref="pnrOdeme" v-model="Odeme"></pnrodeme>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import pnrodeme from "../component/pnrodeme.vue";
export default {
  components: { pnrodeme },
  data() {
    return {
      Odeme: {
        OdemeTarihi: null,
        OdemeTipi: 0,
        NakitBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        KrediKartBilgi: {
          KarsiCari: {
            kod: null,
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
          FirmaKrediKartli: false,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: 0,
          PosKodu: null,
          PosTaksit: null,
          PuanTutari: 0,
        },
        HavaleBilgi: {
          Banka: null,
          Aciklama: null,
        },
        SanalPosBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
        },
        Tutar: 0,
        ParaBirimi: "TL",
        Kur: 1,
        OdemeIadesi: false,
        PNR_No: null,
        EvrakNo: null,
        Aciklama: null,
      },
    };
  },
  methods: {
    odemeEkle() {
      this.$refs.pnrOdeme.addOdeme();
    },
  },
};
</script>

<style>
</style>